import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Import the CSS file

function Footer() {
  return (
    <div className="container">
      <footer className="py-3 my-4">
        <ul className="nav justify-content-center border-bottom pb-3 mb-3">
          {/* Privacy Policy */}
          <li className="nav-item">
            <Link to="/privacy-and-policy" className="nav-link px-2 footer-link">
              Privacy Policy
            </Link>
          </li>

          {/* About Us */}
          <li className="nav-item">
            <Link to="/about-us" className="nav-link px-2 footer-link">
              About Us
            </Link>
          </li>

          {/* Contact Us */}
          <li className="nav-item">
            <Link to="/contact-us" className="nav-link px-2 footer-link">
              Contact Us
            </Link>
          </li>

          {/* Terms and Conditions */}
          <li className="nav-item">
            <Link to="/terms-and-conditions" className="nav-link px-2 footer-link">
              Terms and Conditions
            </Link>
          </li>
        </ul>

        {/* Copyright Text */}
        <p className="text-center copyright-text">
          Copyright © 2025 ebookstore.ct.ws
        </p>
      </footer>
    </div>
  );
}

export default Footer;